var runtime = require("../../../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"container":"_1i5Vm","ratioImage":"E6BV0"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._1i5Vm{position:relative}"+wrap+" .E6BV0{display:block;width:100%;opacity:0;pointer-events:none}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

